import { render } from "./quality_requisition.vue?vue&type=template&id=4657239b&scoped=true"
import script from "./quality_requisition.vue?vue&type=script&lang=js"
export * from "./quality_requisition.vue?vue&type=script&lang=js"

import "./quality_requisition.vue?vue&type=style&index=0&id=4657239b&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4657239b"]])

export default __exports__